import * as React from "react";
import { AlertType } from "../Entities/Constants/AlertConstants";
import { BaseComponent } from "../../../react-core/Html/BaseComponent";

export interface IAlertProps {
    alertType: AlertType;
    message: string | JSX.Element;
    onAlertClose?: () => void;
    cssWrapper?: string;
    css?: string;
    hideCloseButton?: boolean;
}

export interface IAlertState {}

export class Alert extends BaseComponent<IAlertProps, IAlertState> {
    constructor(props: IAlertProps) {
        super(props);
    }

    public render(): JSX.Element {
        const { alertType, message, hideCloseButton } = this.props;
        switch (alertType) {
            case AlertType.Error:
                return <p className={"error-message " + this.props.cssWrapper}>{message}</p>;
            case AlertType.Warning:
                return <p className={"warning-message " + this.props.cssWrapper}>{message}</p>;
            case AlertType.Success:
                return <p className={"success-message " + this.props.cssWrapper}>{message}</p>;
            case AlertType.Notification:
                return (
                    <div className={"notification-message " + this.props.css} role="alert">
                        {message}
                        {!hideCloseButton && (
                            <button type="button" className="close" onClick={() => this.props.onAlertClose()}>
                                <span className="icon" aria-hidden="true"></span>
                                <span className="sr-only">Close notification</span>
                            </button>
                        )}
                    </div>
                );
        }
    }
}
